let initialized = false;
let gaTrackingId = null;

export function isInitialized() {
  return initialized;
}

export function initialize(newGaTrackingId, path, title) {
  if (!initialized) {
    gaTrackingId = newGaTrackingId;

    const cookieConsent = document.cookie
      .split('; ')
      .find(row => row.startsWith('cookie_consent_level'));

    if (!cookieConsent) {
      console.warn("Cookie consent not found or not accepted.");
      return;
    }

    const consentValue = JSON.parse(decodeURIComponent(cookieConsent.split('=')[1]));

    if (!consentValue.tracking) {
      console.warn("Tracking is not enabled in cookie consent.");
      return;
    }

    const gtmScript = document.createElement("script");
    gtmScript.type = "text/javascript";
    gtmScript.async = true;
    gtmScript.src = "https://www.googletagmanager.com/gtag/js?id=" + gaTrackingId;

    document.head.appendChild(gtmScript);

    window.dataLayer = window.dataLayer || [];
    function gtag() {
      window.dataLayer.push(arguments);
    }
    window.gtag = gtag;
    gtag("js", new Date());
    gtag("config", gaTrackingId);

    initialized = true;
  }

  // Always send page_view event when initialize is called
  if (window.gtag && gaTrackingId) {
    window.gtag("event", "page_view", {
      send_to: gaTrackingId,
      page_title: title,
      page_path: path
    });
  } else if (initialized) {
    // This case should ideally not happen if initialized is true, but as a fallback
    console.warn("gtag function or tracking ID not available to send page_view.");
  }
}
